import axios from 'axios';
import { BASE_URL } from './config';

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 500000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
    },
});

axiosInstance.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                const originalRequestUrl = error.config?.url || '';
                if (!originalRequestUrl.includes("/login")) {
                    localStorage.clear();
                    window.location.href = "/";
                }
                return Promise.reject(error)
            } 
        }
        return Promise.reject(error);
    }
);


export { axiosInstance }
